// Suppress the "unload is not allowed in this document" Permissions-Policy violation.
// Chrome/Shopify send `Permissions-Policy: unload=()`, so any addEventListener('unload')
// is refused and logged. Fancybox's hash module binds one unconditionally
// ($(window).one('unload.fb popstate.fb')), as may other vendor/app scripts.
// jQuery skips the native addEventListener whenever special.setup returns anything
// but false, so this makes jQuery stop asking for an event the browser already refuses.
// Gated on the browser actually blocking 'unload', so this is a no-op anywhere the
// event still works (Firefox/Safari) — we only stop asking for what is already refused.
// Must stay at top level — deferred scripts eval before DOMContentLoaded, and Fancybox
// binds inside ready() + setTimeout(50), so this registers first.
(function () {
  var fp = document.featurePolicy;
  var blocked = !!fp && typeof fp.features === 'function' &&
                fp.features().indexOf('unload') > -1 && !fp.allowsFeature('unload');

  if (blocked) {
    jQuery.event.special.unload = {
      setup: function () { return true; },
      teardown: function () { return true; }
    };
  }
})();

$(document).ready(function() {
  // Function to handle active state and image display for each menu
  function handleMenu(menuId) {
    // Set the first item as active by default for this menu
    var firstItem = $('#' + menuId + ' .collection-item').first();
    firstItem.addClass('active');

    // Display the corresponding image for the first item
    var firstCollectionHandle = firstItem.data('collection-handle');
    $('#' + menuId + ' .collection-img').each(function() {
      if ($(this).hasClass('collection-img-' + firstCollectionHandle)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    // On hover, update the active state and show corresponding image for the hovered item
    $('#' + menuId + ' .collection-item').hover(function() {
      // Remove active state from all items in this menu
      $('#' + menuId + ' .collection-item').removeClass('active');
      $(this).addClass('active');
      
      // Show the corresponding image for the hovered item
      var collectionHandle = $(this).data('collection-handle');
      $('#' + menuId + ' .collection-img').each(function() {
        if ($(this).hasClass('collection-img-' + collectionHandle)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    });

    // Optional: Keep the image visible when you leave the hover state (hover off)
    $('#' + menuId + ' .collection-item').mouseleave(function() {
      $(this).removeClass('active');
      // You can make the first collection image visible again if desired
    });
  }

  // Handle first menu (select_menu_pTyfbX)
  handleMenu('select_menu_pTyfbX');

  // Handle second menu (select_menu_Wz4zHF)
  handleMenu('select_menu_Wz4zHF');
});


$(document).ready(function() {
  // Handle click on menu items
  $('.mobile-mega-menu li').click(function(e) {
    e.preventDefault();

    var targetId = $(this).attr('id');
    var targetBox = $('#' + targetId + '.mega-menu.collc-box');
    var mobileMenu = $('.nws-custom-mobile-menu');

    if (targetBox.hasClass('active')) {
      targetBox.removeClass('active');
      mobileMenu.removeClass('active');
    } else {
      $('.mega-menu.collc-box').removeClass('active');
      targetBox.addClass('active');

      mobileMenu.addClass('active');
    }
  });

  // Close menu when h4 inside is clicked
  $('.mega-menu.collc-box .collection-list h4').click(function(e) {
    var parentBox = $(this).closest('.mega-menu.collc-box');
    parentBox.removeClass('active');
    $('.nws-custom-mobile-menu').removeClass('active');
  });
});


jQuery('.hero-box .hero-slide').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 3000,
    nextArrow: `<button type="button" class="slick-next">
                <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 2L12 12L2 22" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>

            </button>`,
            prevArrow: `<button type="button" class="slick-prev">
                <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 12L12 22" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

            </button>`,
    slidesToScroll: 1,

    responsive: [{
        breakpoint: 993,
        settings: {
            dots: true,
            infinite: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }, 

    {
      breakpoint: 768,
      settings: {
          dots: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }, 

    {
      breakpoint: 601,
      settings: {
          dots: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }, 

    {
      breakpoint: 481,
      settings: {
          dots: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }]
}); 

function initMobileSlider() {
    var winWidth = $(window).width();

    // Initialize/Destroy icon-slide-mob for <= 767px
    if (winWidth <= 767) {
        if (!$('.icon-slide-mob').hasClass('slick-initialized')) {
            $('.icon-slide-mob').slick({
                dots: true,
                arrows: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                autoplay: false
            });
        }
    } else {
        if ($('.icon-slide-mob').hasClass('slick-initialized')) {
            $('.icon-slide-mob').slick('unslick');
        }
    }

    // Initialize/Destroy mobile-prod-slide for >= 992px
    if (winWidth <= 900) {
        if (!$('.mobile-prod-slide').hasClass('slick-initialized')) {
            $('.mobile-prod-slide').slick({
                dots: true,
                arrows: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                autoplay: false,
                 nextArrow: `<button type="button" class="slick-next">
                <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.921173 1L3.8418 3.92062L0.921173 6.84125" stroke="black" stroke-width="0.730156" stroke-linecap="round"/>
                </svg>
            </button>`,
            prevArrow: `<button type="button" class="slick-prev">
                <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);">
                    <path d="M0.921173 1L3.8418 3.92062L0.921173 6.84125" stroke="black" stroke-width="0.730156" stroke-linecap="round"/>
                </svg>
            </button>`
            });
        }
    } else {
        if ($('.mobile-prod-slide').hasClass('slick-initialized')) {
            $('.mobile-prod-slide').slick('unslick');
        }
    }
}

$(document).ready(function () {
    initMobileSlider();
});

$(window).on('resize', function () {
    initMobileSlider();
});


$(".faq-item").click(function() {
// Toggle the answer when clicking on a question
$(this).find(".faq-answer").slideToggle(300);

// Close other answers
$(".faq-item").not(this).find(".faq-answer").slideUp(300);
});  

jQuery('.faq-list .accordion-item').click(function(){
  if( jQuery(this).hasClass('active-drop') ) {
      jQuery('.faq-list .accordion-item').removeClass('active-drop');
  } else {
      jQuery('.faq-list .accordion-item').removeClass('active-drop');
      jQuery(this).addClass('active-drop');
  }
});

$(document).ready(function() {
    $.getJSON('/cart.js', function(cart) {
        // Cart items ki total quantity ko calculate karna
        var totalItems = 0;
        $.each(cart.items, function(index, item) {
            totalItems += item.quantity;
        });

        // Total items count ko display karna
        $('#total-items-count').text(totalItems);
    });
});

 // Open Sidebar
$(".nws-icon-open").click(function () {
    $(".nws-custom-mobile-menu").addClass("open");
    $(".nws-custom-mobile-overlay").addClass("menu-sidebar-active");
});

// Close Sidebar
$(".menu-toggle-close").click(function () {
    $(".nws-custom-mobile-menu").removeClass("open");
    $(".nws-custom-mobile-overlay").removeClass("menu-sidebar-active");
});

// Close sidebar when clicking outside
$(document).click(function (event) {
    if (!$(event.target).closest(".nws-custom-mobile-menu, .nws-icon-open").length) {
        $(".nws-custom-mobile-menu").removeClass("open");
        $(".nws-custom-mobile-overlay").removeClass("menu-sidebar-active");
    }
});

jQuery(window).on("scroll", function() {
    if(jQuery(window).scrollTop() > 160) {
        jQuery(".nws-header").addClass("fix_head");
    } else {
    jQuery(".nws-header").removeClass("fix_head");
}
});

jQuery(window).on("scroll", function() {
    if(jQuery(window).scrollTop() > 350) {
        jQuery(".prod-sticky").addClass("fix_head");
    } else {
        jQuery(".prod-sticky").removeClass("fix_head");
    }
});

$(document).ready(function(){
  $('.tab-title').on('click', function(){
    var currentSection = $(this).closest('.foo-toggle');
    
    // If the current section is not active, close all others first
    if (!currentSection.hasClass('active')) {
      $('.foo-toggle.active').removeClass('active')
                              .find('ul.list-unstyled').slideUp();
      
      // Then open the clicked section
      currentSection.addClass('active')
                    .find('ul.list-unstyled').slideDown();
    } else {
      // If it's already active, close it
      currentSection.removeClass('active')
       .find('ul.list-unstyled').slideUp();
    }
  });
});

$(document).ready(function() {
  var currentURL = window.location.pathname;

  $(".list-inline-item a").each(function() {
    var linkPath = $(this).attr("href");

    if (linkPath === currentURL || (linkPath === '/' && currentURL === '/')) {
      $(this).closest(".list-inline-item").addClass("active");
    }
  });
});

jQuery('.testimonial-slide').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: 0,
    slidesToScroll: 1,

    responsive: [{
        breakpoint: 993,
        settings: {
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }, 

    {
      breakpoint: 768,
      settings: {
          dots: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }, 

    {
      breakpoint: 601,
      settings: {
          dots: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }, 

    {
      breakpoint: 481,
      settings: {
          dots: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }]
}); 


jQuery(document).ready(function () {
    if (jQuery('.big_slide').length && jQuery('.min_slide_root').length) {
        initializeSliders();
    } else {
        // Expected on non-product pages: this file loads site-wide, but .big_slide /
        // .min_slide_root only exist in the product sections. Not a bug.
        console.debug('Product slider not present on this page — skipping init.');
    }
});

function initializeSliders() {
    jQuery('.big_slide').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: false,
        touchMove: false,
        swipeToSlide: false,
        infinite: true,
        focusOnSelect: false,
        fade: false,
        autoplay: false,
        asNavFor: '.min_slide_root'
    });
    jQuery('.min_slide_root').slick({
        vertical: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.big_slide',
        infinite: true,
        focusOnSelect: true,
        draggable: true,
        swipeToSlide: true,
        autoplay: false,
        dots: false,
        arrows: true,

        responsive: [
            {
                breakpoint: 1281,
                settings: {
                    slidesToShow: 3,
                    vertical: true,
                    arrows: true,
                    dots: false,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    vertical: false,
                     arrows: false,
                    dots: false,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                  vertical: false,
                     arrows: false,
                    dots: true,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 481,
                settings: {
                    dots: true,
                    arrows: false,
                   vertical: false,
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 415,
                settings: {
                    dots: true,
                  vertical: false,
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

function formatMoney(cents) {
  return "$" + (cents / 100).toFixed(2);
}

$(document).ready(function () {
  $(".size-variant-sltd select").change(function () {
    let selectedOption = $(this).find("option:selected");

    let variantId = selectedOption.val();
    let price = parseInt(selectedOption.data("price"));
    let comparePrice = parseInt(selectedOption.data("cprice"));

    // Update hidden inputs
    $('input.product-variant-id').val(variantId);
    $('#variant-id').val(variantId);

    // Update price
    $("#product-price").text(formatMoney(price));

    if (comparePrice > price) {
      $("#compare-price").text(formatMoney(comparePrice)).show();
    } else {
      $("#compare-price").hide();
    }
  });
});

$(document).ready(function () {
  $('input[name="properties[Option]"], input[type="radio"][name="properties[Logo Colors]"]').change(function () {
    let selectedProductId = $(this).data('product-id');

    // Hide all size selects
    $('.size-select-wrapper').hide();

    // Show the one matching the selected product
    $('.size-select-wrapper[data-product-id="' + selectedProductId + '"]').show();
  });
});


$(document).ready(function() {
  function updateVariantOptions(selectedOption) {
    let lowestPrice = Infinity;
    let lowestOption = null;

    $('.size-variant-sltd select[name="id"] option').each(function() {
      $(this).hide().removeAttr('selected');

      if ($(this).data('set') === selectedOption) {
        $(this).show();

        let price = parseFloat($(this).data('price'));
        if (price < lowestPrice) {
          lowestPrice = price;
          lowestOption = $(this);
        }
      }
    });

    if (lowestOption) {
      lowestOption.prop('selected', true);
      $('.size-variant-sltd select[name="id"]').trigger('change');
    }
  }

  $('input[name="properties[Option]"], input[type="radio"][name="properties[Logo Colors]"]').on('change', function() {
    let selectedOption = $(this).attr("data-val");
    updateVariantOptions(selectedOption);
  });

  let initialSelectedOption = $('input[name="properties[Option]"]:checked, input[type="radio"][name="properties[Logo Colors]"]:checked').attr("data-val");
  if (initialSelectedOption) {
    updateVariantOptions(initialSelectedOption);
  }
});



$(document).ready(function() {
  // Function to update the price displayed on the page
  function updatePrice(price) {
    // Update the product price display with the selected price
    $('#product-price').text('$' + (price / 100).toFixed(2)); // Assuming price is in cents, adjust if needed
  }

  // Function to update the variant options based on the selected radio button
  function updateVariantOptions(selectedOption) {
    let lowestPrice = Infinity; // Start with a high value to find the lowest price
    let lowestPriceOption = null; // Store the option with the lowest price

    // Loop through all select options to find the matching ones
    $('select[name="id"] option').each(function() {
      // Check if this option matches the selected radio value
      if ($(this).data('set') === selectedOption) {
        // Get the price from the matching option
        let price = parseFloat($(this).data('price'));

        // If the current option's price is lower than the lowest found, update
        if (price < lowestPrice) {
          lowestPrice = price;
          lowestPriceOption = $(this); // Save the reference to this option
        }
      }
    });

    // If the lowest price is found, update the displayed price
    if (lowestPriceOption) {
      updatePrice(lowestPrice); // Update the price display with the lowest price
    }
  }

  // Handle radio change event
  $('input[name="properties[Option]"], input[type="radio"][name="properties[Logo Colors]"]').on('change', function() {
    let selectedOption = $(this).attr("data-val");  // Get selected option value
    updateVariantOptions(selectedOption); // Update the variant options and price
  });

  // Trigger once on page load (initial checked option)
  let initialSelectedOption = $('input[name="properties[Option]"]:checked, input[type="radio"][name="properties[Logo Colors]"]:checked').attr("data-val");
  if (initialSelectedOption) {
    updateVariantOptions(initialSelectedOption); // Update the price based on the initially selected radio
  }

  
$('#model_instant').on('shown.bs.modal', function () {
  // Initially hide all answers
  $(this).find('.faq-answer').hide();
});

// Use event delegation for dynamically loaded modal content
$('#model_instant').on('click', '.accordion-item-head', function () {
  const $faqItem = $(this).closest('.faq-item');

  // Toggle clicked item
  $faqItem.find('.faq-answer').stop(true, true).slideToggle(300);

  // Hide all others
  $faqItem.siblings('.faq-item').find('.faq-answer').slideUp(300);
});

$('#model_instant').on('shown.bs.modal', function () {
  const $firstItem = $(this).find('.faq-item').first();
  $firstItem.find('.faq-answer').slideDown(0);
});

});


(function ($) {
  $(document).ready(function () {
    const $variantSelect = $("#product-variant");
    const $priceDisplay = $("#product-price");
    const $comparePriceDisplay = $("#compare-price");
    const $quantityInput = $(".quantity__input");
    const $quantityInputI = $(".quantity__ipt");

    // Ensure hidden input for variant ID exists
    let $hiddenInput = $('input[name="id"]');
    if ($hiddenInput.length === 0) {
      $hiddenInput = $('<input>', {
        type: "hidden",
        name: "id"
      });
      $("form").append($hiddenInput);
    }

    // Remove any previously attached listeners to prevent duplicates
    $(document).off("click.quantity");
    $(document).off("input.quantity change.quantity");
    $variantSelect.off("change.quantity");

    // Update function
    function updateVariantAndPrice() {
      const quantity = parseInt($quantityInputI.val(), 10) || 1;
      const $selectedOption = $variantSelect.find("option:selected");

      let variantId = $selectedOption.val();
      let price = $selectedOption.data("price");
      let comparePrice = $selectedOption.data("cprice");

      if (quantity >= 26 && $selectedOption.data("26qty")) {
        variantId = $selectedOption.data("26qty");
        price = $selectedOption.data("26price");
        comparePrice = $selectedOption.data("26cprice");
      } else if (quantity >= 11 && $selectedOption.data("11qty")) {
        variantId = $selectedOption.data("11qty");
        price = $selectedOption.data("11price");
        comparePrice = $selectedOption.data("11cprice");
      } else if (quantity >= 3 && $selectedOption.data("3qty")) {
        variantId = $selectedOption.data("3qty");
        price = $selectedOption.data("3price");
        comparePrice = $selectedOption.data("3cprice");
      } else if (quantity >= 2 && $selectedOption.data("2qty")) {
        variantId = $selectedOption.data("2qty");
        price = $selectedOption.data("2price");
        comparePrice = $selectedOption.data("2cprice");
      }

      $hiddenInput.val(variantId);

      if ($priceDisplay.length && price) {
        $priceDisplay.text(`$${(parseInt(price, 10) / 100).toFixed(2)}`);
      }

      if ($comparePriceDisplay.length) {
        if (comparePrice) {
          $comparePriceDisplay
            .text(`$${(parseInt(comparePrice, 10) / 100).toFixed(2)}`)
            .show();
        } else {
          $comparePriceDisplay.hide();
        }
      }
    }

    // Quantity buttons click
    $(document).on("click.quantity", ".quantity__button", function () {
      let currentVal = parseInt($quantityInputI.val(), 10) || 1;
      if ($(this).attr("name") === "plus") {
        currentVal += 1;
      } else if ($(this).attr("name") === "minus") {
        currentVal = Math.max(1, currentVal - 1);
      }
      $quantityInputI.val(currentVal);
      updateVariantAndPrice();
    });

    // Quantity input change (typing manually)
    $(document).on("input.quantity change.quantity", ".quantity__input", function () {
      updateVariantAndPrice();
    });

    // Variant change
    $variantSelect.on("change.quantity", function () {
      updateVariantAndPrice();
    });

    // Initial update
    updateVariantAndPrice();
  });
})(jQuery);

(function ($) {
  $(document).ready(function () {
    const $variantSelect = $("#product-variant");
    const $priceDisplay = $("#product-price");
    const $comparePriceDisplay = $("#compare-price");
    const $quantityInputs = $(".quantity__input");
    const $hiddenQtyInputs = $(".quantity__ipt");

    // Ensure hidden input for variant ID exists
    let $hiddenInput = $('input[name="id"]');
    if ($hiddenInput.length === 0) {
      $hiddenInput = $('<input>', {
        type: "hidden",
        name: "id"
      });
      $("form").append($hiddenInput);
    }

    // Remove any previously attached listeners to prevent duplicates
    $(document).off("click.quantity");
    $(document).off("input.quantity change.quantity");
    $variantSelect.off("change.quantity");

    // Update function
    function updateVariantAndPrice(quantity) {
      const qty = parseInt(quantity, 10) || 1;
      const $selectedOption = $variantSelect.find("option:selected");

      let variantId = $selectedOption.val();
      let price = $selectedOption.data("price");
      let comparePrice = $selectedOption.data("cprice");

      if (qty >= 26 && $selectedOption.data("26qty")) {
        variantId = $selectedOption.data("26qty");
        price = $selectedOption.data("26price");
        comparePrice = $selectedOption.data("26cprice");
      } else if (qty >= 11 && $selectedOption.data("11qty")) {
        variantId = $selectedOption.data("11qty");
        price = $selectedOption.data("11price");
        comparePrice = $selectedOption.data("11cprice");
      } else if (qty >= 3 && $selectedOption.data("3qty")) {
        variantId = $selectedOption.data("3qty");
        price = $selectedOption.data("3price");
        comparePrice = $selectedOption.data("3cprice");
      } else if (qty >= 2 && $selectedOption.data("2qty")) {
        variantId = $selectedOption.data("2qty");
        price = $selectedOption.data("2price");
        comparePrice = $selectedOption.data("2cprice");
      }

      $hiddenInput.val(variantId);

      if ($priceDisplay.length && price) {
        $priceDisplay.text(`$${(parseInt(price, 10) / 100).toFixed(2)}`);
      }

      if ($comparePriceDisplay.length) {
        if (comparePrice) {
          $comparePriceDisplay
            .text(`$${(parseInt(comparePrice, 10) / 100).toFixed(2)}`)
            .show();
        } else {
          $comparePriceDisplay.hide();
        }
      }
    }

    // Quantity button click (plus/minus)
    $(document).on("click.quantity", ".quantity__button", function () {
      let currentVal = parseInt($quantityInput.val(), 10) || 1;
      if ($(this).attr("name") === "plus") {
        currentVal += 1;
      } else if ($(this).attr("name") === "minus") {
        currentVal = Math.max(1, currentVal - 1);
      }
      $quantityInput.val(currentVal);
      updateVariantAndPrice();
    });

    // Quantity manual input (typing)
    $(document).on("input.quantity change.quantity", ".quantity__input", function () {
      const $input = $(this);
      const quantity = $input.val();
      const $hiddenQty = $input.siblings(".quantity__ipt");

      $hiddenQty.val(quantity); // Sync hidden with typed value
      updateVariantAndPrice(quantity);
    });

    // Variant change
    $variantSelect.on("change.quantity", function () {
      const quantity = $hiddenQtyInputs.first().val(); // Use hidden input value
      updateVariantAndPrice(quantity);
    });

    // Initial update
    updateVariantAndPrice($hiddenQtyInputs.first().val());
  });
})(jQuery);
